import request, { type ApiResponse, type RequestConfig } from "@/utils/request";

export const wxLogin = (code: string, config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.get('/app/wecom/auth/callback', { code }, config);
};

export const getCurrentUser = (config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.get('/app/wecom/auth/current', undefined, config);
}

// 检查token是否过期
export const checkToken = (token: string, config?: RequestConfig): Promise<ApiResponse<boolean>> => {
  return request.get('/app/wecom/auth/token/check', { token }, config);
}

export const permitAccount = (config?: RequestConfig): Promise<ApiResponse<string[]>> => {
  return request.get('/app/wecom/auth/permitAccount', undefined, config);
}